import { c as _c } from "react/compiler-runtime";
import Link from '@/components/elements/Link';
import Tooltip from '@/components/modules/Tooltip';
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Tag } from '@winelidays/wld-tsx-2/elements';
import { InfoIcon } from '@winelidays/wld-tsx-2/images';
import { formatPrice } from '@winelidays/wld-tsx-2/utils';
const PriceTag = t0 => {
    const $ = _c(21);
    const { total, items } = t0;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    let t1;
    if ($[0] !== currencySymbol || $[1] !== total || $[2] !== translate) {
        t1 = translate("availability.total_price", {
            total: formatPrice(total),
            currencySymbol
        });
        $[0] = currencySymbol;
        $[1] = total;
        $[2] = translate;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const name = t1;
    let t2;
    if ($[4] !== currencySymbol || $[5] !== items || $[6] !== translate) {
        let t3;
        if ($[8] !== currencySymbol || $[9] !== translate) {
            t3 = t4 => {
                const { ageRange: t5, count, price } = t4;
                const { lower, upper } = t5;
                return <li key={`${lower}`} className="flex flex-row justify-between text-xs mb-1"><span className="text-gray-400 pr-2">{translate("availability.calculated_price.label", {
                        lower: lower ?? 0,
                        upper
                    })}</span><span className="text-right">{translate("availability.calculated_price.value", {
                        count,
                        price: formatPrice(price),
                        currencySymbol
                    })}</span></li>;
            };
            $[8] = currencySymbol;
            $[9] = translate;
            $[10] = t3;
        }
        else {
            t3 = $[10];
        }
        t2 = items.map(t3);
        $[4] = currencySymbol;
        $[5] = items;
        $[6] = translate;
        $[7] = t2;
    }
    else {
        t2 = $[7];
    }
    let t3;
    if ($[11] !== t2) {
        t3 = <ul>{t2}</ul>;
        $[11] = t2;
        $[12] = t3;
    }
    else {
        t3 = $[12];
    }
    const tooltipContent = t3;
    let t4;
    if ($[13] !== name) {
        t4 = <Tag data-dispo={true} name={name} className="bg-gray-700 border-gray-700 text-xxs" square={true} contrast={true} tabIndex={-1} linkComponent={Link}/>;
        $[13] = name;
        $[14] = t4;
    }
    else {
        t4 = $[14];
    }
    let t5;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <span data-dispo={true} className="text-gray-700 text-opacity-50 px-1 mr-2" tabIndex={-1}><InfoIcon /></span>;
        $[15] = t5;
    }
    else {
        t5 = $[15];
    }
    let t6;
    if ($[16] !== t4) {
        t6 = <button className="flex flex-row items-center my-1" data-dispo={true}>{t4}{t5}</button>;
        $[16] = t4;
        $[17] = t6;
    }
    else {
        t6 = $[17];
    }
    let t7;
    if ($[18] !== t6 || $[19] !== tooltipContent) {
        t7 = <Tooltip content={tooltipContent} className="font-semibold">{t6}</Tooltip>;
        $[18] = t6;
        $[19] = tooltipContent;
        $[20] = t7;
    }
    else {
        t7 = $[20];
    }
    return t7;
};
export default PriceTag;
